<template>
  <div class="page">
    <!--头部-->
    <div class="title"><i class="iconfont icon-skudazhe"></i>SKU属性浏览</div>

    <div class="page-content">
      <!--body-->
      <el-main style="overflow: hidden">
        <!--新增角色按钮-->
        <el-row style="float: left">
          <el-form style="font: bold" :inline="true" label-width="100px" size="small" :model="formInline">
            <el-form-item label="SKU：">
              <el-input v-model="formInline.sku" clearable placeholder="SKU"></el-input>
            </el-form-item>
            <el-form-item label="属性：">
              <el-input v-model="formInline.attribute" clearable placeholder="属性"></el-input>
            </el-form-item>
            <el-form-item label="数据类型：">
              <el-select v-model="formInline.type" clearable placeholder="请选择">
                <el-option label="请选择" value />
                <el-option v-for="types in dataTypes" :key="types.id" :value="types.id" v-text="types.name" :label="types.name" />
              </el-select>
            </el-form-item>
            <el-form-item label="店铺：">
              <el-select v-model="formInline.shopName" style="width: 100%" clearable filterable placeholder="请选择">
                <el-option v-for="types in dataShops" :key="types.id" :value="types.shopName" v-text="types.shopName" :label="types.shopName" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="queryParams" style="backgroundcolor: #2a3861; bordercolor: transparent">查询 </el-button>
              <el-button type="primary" @click="addSkuinfo" style="backgroundcolor: #2a3861; bordercolor: transparent">新增 </el-button>
              <el-button type="primary" @click="templateDownload()" style="backgroundcolor: #2a3861; bordercolor: transparent">下载模板 </el-button>
              <el-button type="primary" @click="importSkuInfo()" style="backgroundcolor: #2a3861; bordercolor: transparent">导入 </el-button>
              <el-button type="primary" @click="exportSkuInfo()" style="backgroundcolor: #2a3861; bordercolor: transparent">导出 </el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <!-- 表格区域  :loading="loading"-->
        <el-table
          height="calc(100vh - 1.8rem)"
          :data="tableData"
          border
          :header-cell-style="{
            'text-align': 'center',
            background: '#F5F6FA',
            color: '#646E92',
          }"
          style="
            width: 96%;
            margin-top: 30px;
            margin-left: 25px;
            color: #666e92;
            font-size: 14px;
          "
          :cell-style="{ 'text-align': 'center' }"
          @cell-dblclick="editData"
        >
          <el-table-column prop="sku" label="SKU" fixed width="220" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.sku }}
            </template>
          </el-table-column>
          <el-table-column prop="attribute" label="属性" width="220" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.attribute }}
            </template>
          </el-table-column>
          <el-table-column prop="numberPackages" label="装箱数" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.numberPackages }}
            </template>
          </el-table-column>
          <el-table-column prop="fnsku" label="FNSKU" width="220" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.fnsku }}
            </template>
          </el-table-column>
          <el-table-column prop="type" label="类别" width="100" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.type == "11002001" ? "内部" : scope.row.type == "11002002" ? "外部" : "" }}
            </template></el-table-column
          >

          <el-table-column prop="shopName" label="店铺" show-overflow-tooltip width="220">
            <template slot-scope="scope">
              {{ scope.row.shopName }}
            </template>
          </el-table-column>
          <el-table-column prop="site" label="站点" width="100" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.site }}
            </template>
          </el-table-column>

          <el-table-column prop="cost" label="成本" width="100" show-overflow-tooltip>
            <template slot-scope="scope">
              <div v-if="row === scope.row.id && col == scope.column.id && (roleCode == 'LYA001' || roleCode == 'LYA002')">
                <el-input v-model="tmpRow.cost" size="mini" type="number" @blur="updateskuInfo" />
              </div>
              <div v-else>
                {{ scope.row.cost }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="packagesLong" label="装箱(长) CM" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <div v-if="row === scope.row.id && col == scope.column.id">
                <el-input v-model="tmpRow.packagesLong" size="mini" type="number" @blur="updateskuInfo" />
              </div>
              <div v-else>
                {{ scope.row.packagesLong }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="packagesWide" label="装箱(宽) CM" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <div v-if="row === scope.row.id && col == scope.column.id">
                <el-input v-model="tmpRow.packagesWide" size="mini" type="number" @blur="updateskuInfo" />
              </div>
              <div v-else>
                {{ scope.row.packagesWide }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="packagesHigh" label="装箱(高) CM" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <div v-if="row === scope.row.id && col == scope.column.id">
                <el-input v-model="tmpRow.packagesHigh" size="mini" type="number" @blur="updateskuInfo" />
              </div>
              <div v-else>
                {{ scope.row.packagesHigh }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="packagesWeight" label="装箱重量 KG" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <div v-if="row === scope.row.id && col == scope.column.id">
                <el-input v-model="tmpRow.packagesWeight" size="mini" type="number" @blur="updateskuInfo" />
              </div>
              <div v-else>
                {{ scope.row.packagesWeight }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="hytcNew" label="头程费" width="100" show-overflow-tooltip>
            <template slot-scope="scope">
              <div v-if="row === scope.row.id && col == scope.column.id && (roleCode == 'LYA001' || roleCode == 'LYA002')">
                <el-input v-model="tmpRow.hytcNew" size="mini" type="number" @blur="updateskuInfo" />
              </div>
              <div v-else>
                {{ scope.row.hytcNew }}
              </div>
            </template>
          </el-table-column>

          <el-table-column align="center" width="150" fixed="right">
            <template slot="header" slot-scope="scope">
              <span>操作</span>
            </template>
            <template slot-scope="scope" align="center">
              <el-link :underline="false" style="color: #7698fc" @click="editSkuinfo(scope.row)"><i class="el-icon-edit-outline fs-icon" title="编辑"></i></el-link>
              <el-link :underline="false" type="danger" @click="deleteRoleGetId(scope.row)"><i class="el-icon-delete fs-icon" title="删除"></i
              ></el-link>
              <el-link
                :underline="false"
                class="fs-icon"
                style="
                  color: #2cc7c7;
                "
                @click="uploadOrderfile(scope.row)"
                ><i class="el-icon-upload2" title="上传"></i
              ></el-link>
              <el-link
                :underline="false"
                class="fs-icon"
                style="
                  color: #2b69ee;
                "
                @click="clickFnskuDown(scope.row)"
                ><i class="el-icon-download" title="下载"></i
              ></el-link>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <!--尾部-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        :page-sizes="[10, 15, 20, 25, 30]"
        layout="total, sizes,prev, pager, next, jumper"
        :total="total"
        background
      />
      <!-- 新增sku弹框 -->
      <el-dialog :title="modelTitle" width="600px" :visible.sync="addRoleDialog" class="showAll_dialog" :close-on-click-modal="false" :show-close="false" left>
        <el-form label-width="130px" :model="addrole" ref="addrole" :rules="rules1">
          <el-form-item label="SKU：" prop="sku">
            <el-input v-model="addrole.sku"></el-input>
          </el-form-item>
          <el-form-item label="类别：" prop="type">
            <!-- <el-input v-model="addrole.type"></el-input> -->
            <el-select v-model="addrole.type" value-key="id" filterable clearable style="width: 100%">
              <el-option v-for="types in dataTypes" :key="types.id" :value="types.id" :label="types.name" />
            </el-select>
          </el-form-item>
          <el-form-item label="属性：" prop="attribute">
            <el-input v-model="addrole.attribute"></el-input>
          </el-form-item>
          <el-form-item label="装箱数：" prop="numberPackages">
            <el-input v-model="addrole.numberPackages"></el-input>
          </el-form-item>
          <el-form-item label="FNSKU：" prop="fnsku">
            <el-input v-model="addrole.fnsku"></el-input>
          </el-form-item>
          <el-form-item label="店铺：" prop="shopName">
            <!-- <el-input v-model="addrole.shopName"></el-input> -->
            <el-select v-model="addrole.shopName" style="width: 100%" clearable filterable placeholder="请选择" @change="realChange">
              <el-option v-for="types in dataShops" :key="types.id" :value="types.shopName" v-text="types.shopName" :label="types.shopName" />
            </el-select>
          </el-form-item>
          <el-form-item label="站点：" prop="site">
            <el-select v-model="addrole.site" style="width: 100%" clearable placeholder="请选择">
              <el-option v-for="types in dataSites" :key="types.codeValue" :value="types.codeValue" v-text="types.codeName" :label="types.codeName" />
            </el-select>
          </el-form-item>
          <el-form-item label="成本：" prop="cost">
            <div v-if="roleCode == 'LYA001' || roleCode == 'LYA002'">
              <el-input type="number" v-model="addrole.cost"></el-input>
            </div>
            <div v-else>
              <el-input type="number" v-model="addrole.cost" disabled></el-input>
            </div>
          </el-form-item>
          <el-form-item label="	装箱(长) CM：" prop="packagesLong">
            <el-input type="number" v-model="addrole.packagesLong"></el-input>
          </el-form-item>
          <el-form-item label="装箱(宽) CM：" prop="packagesWide">
            <el-input type="number" v-model="addrole.packagesWide"></el-input>
          </el-form-item>
          <el-form-item label="装箱(高) CM：" prop="packagesHigh">
            <el-input type="number" v-model="addrole.packagesHigh"></el-input>
          </el-form-item>
          <el-form-item label="装箱重量 KG：" prop="packagesWeight">
            <el-input type="number" v-model="addrole.packagesWeight"></el-input>
          </el-form-item>
          <el-form-item label="头程费：" prop="hytcNew">
            <div v-if="roleCode == 'LYA001' || roleCode == 'LYA002'">
              <el-input type="number" v-model="addrole.hytcNew"></el-input>
            </div>
            <div v-else>
              <el-input type="number" v-model="addrole.hytcNew" disabled></el-input>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button @click="cancelSku()">取 消</el-button>
            <el-button @click="addRole('addrole')" style="background-color: #4c74e0; color: white">提 交</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

      <!-- 导入sku文件 -->
      <el-dialog title="上传文件" width="35%" :visible.sync="importSkuInfoShow" class="import-dialog" :close-on-click-modal="false" left>
        <el-form ref="addEditForm" label-width="125px">
          <el-form-item label="上传文件：">
            <el-upload
              class="upload-demo"
              ref="upload"
              drag
              :multiple="false"
              action="javascript:void(0)"
              :file-list="fileList"
              :auto-upload="false"
              :on-change="submitUpload"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
          </el-form-item>

          <!-- <el-form-item style="text-align: right">
            <el-button style="background-color: #5881e8; color: white"
              >确定</el-button
            >
            <el-button @click="importSkuInfoShow = false">取消</el-button> 
          </el-form-item>-->
        </el-form>
      </el-dialog>
      <!-- 上传FNSKU -->
      <el-dialog title="上传FNSKU" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false" center class="center-dialog">
        <span slot="footer" class="dialog-footer">
          <el-button @click="uploadBtnChange(0)" icon="iconfont icon-shujuxiazai" type="primary" style="margin-right: 20px">PDF文件</el-button>

          <el-button @click="uploadBtnChange(1)" icon="iconfont icon-shujuxiazai" type="primary" style="margin-right: 20px">相关文件</el-button>
        </span>
      </el-dialog>
      <!-- 上传文件 -->
      <el-dialog title="上传文件" :visible.sync="uploadDialog" width="500px" class="center-dialog" :close-on-click-modal="false" left>
        <el-form label-width="150px" :model="Fnupload" ref="f1" :rules="rules1">
          <el-form-item :label="formFilename" prop="fileList">
            <el-upload
              class="upload-demo"
              ref="upload"
              :multiple="false"
              action="javascript:void(0)"
              :file-list="fileFnList"
              :auto-upload="false"
              :on-change="submitFnUpload"
            >
              <el-button slot="trigger" size="small" style="background-color: #2cc7c7; color: white">选取文件</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="uploadDialog = false">取 消</el-button>
        <el-button
          @click="doUpload"
          style="background-color: #2cc7c7; color: white"
          >完 成</el-button
        >
      </span> -->
      </el-dialog>
      <!-- 下载文件 -->
      <el-dialog title="下载文件" :visible.sync="downDialog" width="500px" class="center-dialog" :close-on-click-modal="false" center>
        <span slot="footer" class="dialog-footer">
          <el-button @click="downFileFnsku(0)" class="el-icon-download" type="primary" style="margin-right: 20px">PDF文件下载</el-button>

          <el-button @click="downFileFnsku(1)" class="el-icon-download" style="margin-right: 20px" type="primary">相关文件下载</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ElRow from "element-ui/packages/row/src/row";
import ElMain from "element-ui/packages/main/src/main";
import ElFooter from "element-ui/packages/footer/src/main";
import moment from "moment";
import SparkMD5 from "spark-md5";
export default {
  components: {
    ElFooter,
    ElMain,
    ElRow,
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  data() {
    var user = JSON.parse(window.sessionStorage["user"]);
    return {
      importSkuInfoShow: false,
      file: {},
      filterText: "" /*树形筛选绑定*/,
      props: {
        /*配置树形权限菜单显示*/
        label: "name",
        children: "children",
      },
      dataTypes: [
        {
          name: "内部",
          id: 11002001,
        },
        {
          name: "外部",
          id: 11002002,
        },
      ],
      /*创建角色*/
      addRoleDialog: false,
      addrole: {
        id: undefined,
        sku: "",
        attribute: "",
        numberPackages: "",
        fnsku: "",
        type: 11002001,
        site: "",
        shopName: "",
        packagesHigh: "",
        cost: "",
        packagesLong: "",
        packagesWeight: "",
        packagesWide: "",
        hytcNew: ""
      },
      modelTitle: "",
      /*编辑角色*/
      editRoleDialog: false,
      editrole: {
        id: undefined,
        name: "",
        description: "",
        authorityIds: [],
      },
      rules1: {
        sku: [{ required: true, message: "sku是必填的", trigger: "blur" }],
        numberPackages: [{ required: true, message: "装箱数是必填的", trigger: "blur" }],
        attribute: [{ required: true, message: "属性是必填的", trigger: "blur" }],
        fnsku: [{ required: true, message: "fnsku是必填的", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        shopName: [{ required: true, message: "请选择店铺", trigger: "change" }],
        site: [{ required: true, message: "请选择站点", trigger: "change" }],
      },
      data: [{}] /*绑定新增角色树的数据*/,
      formInline: {
        sku: "",
        attribute: "",
        type: "",
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      btn: false,
      fileList: [],
      file: {},
      row: "",
      col: "",
      tmpRow: {},
      Fnupload: {
        id: "",
        businessType: "",
      },
      uploadDialog: false,
      dialogVisible: false,
      fileFnList: [],
      businessType: 0,
      formFilename: "上传文件",
      downDialog: false,
      downDetailfnskuPdfPath: "",
      skuId: "",
      dataSites: [],
      dataShops: [],
      flagClick: false,
      // 双击修改
      attribute: false,
      cost: false,
      failReason: false,
      fnsku: false,
      numberPackages: false,
      packagesHigh: false,
      packagesLong: false,
      packagesWeight: false,
      packagesWide: false,
      shopName: false,
      site: false,
      sku: false,
      type: false,
      user: user,
      roleCode: user.roleCode,
    };
  },
  created() {
    this.query(); /*绑定树*/
    this.getAllDicts();
    this.getShops();
  },
  methods: {
    getShops() {
      /*获取所有店铺*/
      this.axios.get("/api/shop/list").then((r) => {
        if (r.data.code == 200) {
          let data = r.data.data;
          this.dataShops = data;
        }
      });
    },
    getAllDicts() {
      /*获取所有字典*/
      this.axios.get("/api/dict/map").then((r) => {
        let data = r.data.data;
        for (var key in data) {
          if (key.indexOf("1130") == 0) {
            let siteData = data[key];
            siteData.map((item) => {
              item.codeName = item.codeValue + "（" + item.codeName + "）";
            });
            this.dataSites = siteData;
          }
        }
      });
    },
    realChange(val) {
      var obj = {};
      obj = this.dataShops.find(function(i) {
        return i.id === val;
      });
      this.formInline.shopName = obj.shopName;
    },
    // 双击编辑修改sku单元格数据
    editData(row, column) {
      if (column.label.indexOf("SKU") == 0) {
        this.sku = true;
      } else if (column.label.indexOf("属性") == 0) {
        this.attribute = true;
      } else if (column.label.indexOf("装箱数") == 0) {
        this.numberPackages = true;
      } else if (column.label.indexOf("FNSKU") == 0) {
        this.fnsku = true;
      } else if (column.label.indexOf("店铺") == 0) {
        this.shopName = true;
      } else if (column.label.indexOf("站点") == 0) {
        this.site = true;
      } else if (column.label.indexOf("成本") == 0) {
        this.cost = true;
      } else if (column.label.indexOf("装箱(长) CM") == 0) {
        this.packagesLong = true;
      } else if (column.label.indexOf("装箱(宽) CM") == 0) {
        this.packagesWide = true;
      } else if (column.label.indexOf("装箱(高) CM") == 0) {
        this.packagesHigh = true;
      } else if (column.label.indexOf("装箱重量 KG") == 0) {
        this.packagesWeight = true;
      } else if (column.label.indexOf("类别") == 0) {
        this.type = true;
      } else if (column.label.indexOf("头程费") == 0) {
        this.hytcNew = true;
      }
      this.row = row.id;
      this.col = column.id;
      this.tmpRow = row;
      this.tmpRow.id = row.id;
      this.tmpRow.label = column.label;
    },

    //修改信息后调用修改信息的Api
    //双击失焦后的事件
    updateskuInfo() {
      let order = "";
      if (this.sku && this.tmpRow.label == "SKU") {
        order = { id: this.tmpRow.id, sku: this.tmpRow.sku };
      } else if (this.attribute && this.tmpRow.label == "属性") {
        order = { id: this.tmpRow.id, attribute: this.tmpRow.attribute };
      } else if (this.numberPackages && this.tmpRow.label == "装箱数") {
        order = { id: this.tmpRow.id, numberPackages: this.tmpRow.numberPackages };
      } else if (this.fnsku && this.tmpRow.label == "FNSKU") {
        order = { id: this.tmpRow.id, fnsku: this.tmpRow.fnsku };
      } else if (this.shopName && this.tmpRow.label == "店铺") {
        order = { id: this.tmpRow.id, shopName: this.tmpRow.shopName };
      } else if (this.cost && this.tmpRow.label == "成本") {
        order = { id: this.tmpRow.id, cost: this.tmpRow.cost };
      } else if (this.packagesLong && this.tmpRow.label == "装箱(长) CM") {
        order = { id: this.tmpRow.id, packagesLong: this.tmpRow.packagesLong };
      } else if (this.packagesWide && this.tmpRow.label == "装箱(宽) CM") {
        order = { id: this.tmpRow.id, packagesWide: this.tmpRow.packagesWide };
      } else if (this.packagesHigh && this.tmpRow.label == "装箱(高) CM") {
        order = { id: this.tmpRow.id, packagesHigh: this.tmpRow.packagesHigh };
      } else if (this.packagesWeight && this.tmpRow.label == "装箱重量 KG") {
        order = { id: this.tmpRow.id, packagesWeight: this.tmpRow.packagesWeight };
      } else if (this.type && this.tmpRow.label == "类别") {
        order = { id: this.tmpRow.id, type: this.tmpRow.type };
      } else if (this.site && this.tmpRow.label == "站点") {
        order = { id: this.tmpRow.id, site: this.tmpRow.site };
      } else if (this.hytcNew && this.tmpRow.label == "头程费") {
        order = { id: this.tmpRow.id, hytcNew: this.tmpRow.hytcNew };
      }
      console.log(order, "role");
      if (order != null && order != "") {
        this.axios.put("/api/sku-info/modify", order).then(
          (resp) => {
            if (resp.data.code == 200) {
              this.$message("修改成功");
              this.query(); /*查询渲染界面*/
            } else {
              this.$message.info(resp.data.msg);
            }
            //清空数据
            this.tmpRow = {};
            this.row = "";
            this.col = "";
          },
          (err) => {
            console.log("err", err);
          }
        );
      }
    },

    formatTime(row, column) {
      let date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
    handleSizeChange(val) {
      /*改变显示条数*/
      this.pageSize = val;
      this.currentPage = 1;
      this.query();
    },
    handleCurrentChange() {
      this.query();
    },
    putdata(resp) {
      this.$data.tableData = resp.data.data && resp.data.data.records ? resp.data.data.records : [];
      this.$data.total = resp.data.data.total;
      this.$data.user = JSON.parse(sessionStorage.getItem("user"));
      this.$data.roleCode = this.$data.user.roleCode;
    },
    queryParams() {
      this.$data.currentPage = 1;
      this.query();
    },
    query() {
      //条件筛选
      let o = {
        ...this.formInline,
      };
      this.axios
        .get("/api/sku-info/page", {
          // , sku: this.$data.formInline.sku, type: this.$data.formInline.type
          params: { ...o, current: this.$data.currentPage, size: this.$data.pageSize },
        })
        .then(this.putdata, (err) => {
          console.log("err", err);
        });
    },
    addSkuinfo() {
      this.addRoleDialog = true;
      this.modelTitle = "新增SKU信息";
      this.flagClick = true;
    },
    cancelSku() {
      // if (this.flagClick) {
      //   this.$refs.addrole.resetFields();
      // } else {
      this.addrole = {
        id: undefined,
        sku: "",
        attribute: "",
        numberPackages: "",
        fnsku: "",
        type: 11002001,
        site: "",
        shopName: "",
        packagesHigh: "",
        cost: "",
        packagesLong: "",
        packagesWeight: "",
        packagesWide: "",
      };
      // }
      this.addRoleDialog = false;
    },
    editSkuinfo(row) {
      /*绑定修改信息*/
      this.addRoleDialog = true;
      this.modelTitle = "修改SKU信息";
      this.addrole = JSON.parse(JSON.stringify(row));
    },
    addRole(addrole) {
      /*新增修改*/
      this.$refs[addrole].validate((valid) => {
        if (valid) {
          let role = { ...this.addrole };
          if (role.id) {
            this.axios.put("/api/sku-info/modify", role).then(
              (resp) => {
                if (resp.data.code == 200) {
                  this.$message("修改成功");
                  this.query(); /*查询渲染界面*/
                } else {
                  this.$message.info(resp.data.msg);
                }
              },
              (err) => {
                console.log("err", err);
              }
            );
          } else {
            this.axios.post("/api/sku-info/add", role).then(
              (resp) => {
                if (resp.data.code == 200) {
                  this.$message("添加成功");
                  this.query(); /*查询渲染界面*/
                } else {
                  this.$message.info(resp.data.msg);
                }
              },
              (err) => {
                console.log("err", err);
              }
            );
          }
          this.cancelSku(); /*关闭弹窗*/
        } else {
          console.log("验证没通过");
          return false;
        }
      });
    },
    // 导入
    importSkuInfo() {
      this.importSkuInfoShow = true;
    },
    templateDownload() {
      this.$msgbox
        .confirm("此操作将下载模板, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          //let baseurl = this.axios.defaults.baseURL;
          let path = "/api/sku-info/templateDownload?path=/order/template/SKU信息维护.xlsx";
          //window.open(`${baseurl}/api/sku-info/templateDownload?path=` + path, "_blank");
          this.axios({
            url: path,
            method: 'get',
            responseType: 'blob',
          }).then(res => {
              console.log('res', res);
              this.downloadCallback(res, this.getFileName(res));
            }
          ).catch(err => {
            console.log(err.message);
          });
          /*加个下载成功的进度条*/
          setTimeout(() => {
            this.$message({
              message: "下载成功",
              type: "success",
              center: true,
            });
          }, 500);
        })
        .catch(() => {
          this.$message.error("已取消下载");
        });
    },
    exportSkuInfo() {
      this.$msgbox
        .confirm("此操作将导出所有SKU信息, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          let path = '/api/sku-info/exportSkuInfo?1=1';
          if (this.formInline.sku) {
            path += "&sku=" + this.formInline.sku;
          }
          if (this.formInline.attribute) {
            path += "&attribute=" + this.formInline.attribute;
          }
          if (this.formInline.type) {
            path += "&type=" + this.formInline.type;
          }
          if (this.formInline.shopName) {
            path += "&shopName=" + this.formInline.shopName;
          }
          this.axios({
            url: path,
            method: 'get',
            responseType: 'blob',
          }).then(res => {
              console.log('res', res);
              this.downloadCallback(res, this.getFileName(res));
            }
          ).catch(err => {
            console.log(err.message);
          });
          
          // let baseurl = this.axios.defaults.baseURL;
          // let path = "/order/template/SKU信息维护.xlsx";
          // window.open(`${baseurl}/api/sku-info/exportSkuInfo`, "_blank");
          // /*加个下载成功的进度条*/
          // setTimeout(() => {
          //   this.$message({
          //     message: "下载成功",
          //     type: "success",
          //     center: true,
          //   });
          // }, 500);
        })
        .catch(() => {
          this.$message.error("已取消下载");
        });
    },
    downloadCallback(res, fileName) {
      var blob = new Blob([res.data], 
        {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8'});
        var download = document.createElement('a');
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        download.style.display = 'none';
        download.href = href;
        download.download =fileName ; //下载后文件名
        document.body.appendChild(download);
        download.click(); //点击下载
        document.body.removeChild(download); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
    },
    getFileName(res) {
      let fileName=decodeURI((res.headers['content-disposition'].split('='))[1]);
      return fileName;
    },
    deleteRoleGetId(row) {
      /*删除角色*/
      this.$msgbox
        .confirm("此操作将删除SKU信息, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          this.axios.delete("/api/sku-info/removeById?id=" + row.id).then(
            (resp) => {
              if (resp.data.code == 200) {
                this.$message("删除成功");
                this.query();
              } else {
                this.$message(resp.data.msg);
              }
            },
            (err) => {
              console.log("err", err);
            }
          );
        })
        .catch(() => {
          this.$message.error("已取消");
        });
    },
    submitUpload(file, fileList) {
      this.file = file;
      let s = file.name;
      this.fileList = fileList.slice(-1);
      this.generatorFileMd5(file, this.setMD5);
    },
    generatorFileMd5(file, callback) {
      //声明必要的变量
      var fileReader = new FileReader(),
        //文件每块分割2M，计算分割详情
        chunkSize = 2097152,
        chunks = Math.ceil(file.size / chunkSize),
        currentChunk = 0,
        //创建md5对象（基于SparkMD5）
        spark = new SparkMD5();
      let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
      //每块文件读取完毕之后的处理
      fileReader.onload = function(e) {
        let called = false;
        //每块交由sparkMD5进行计算
        spark.appendBinary(e.target.result);
        currentChunk++;

        //如果文件处理完成计算MD5，如果还有分片继续处理
        if (currentChunk < chunks) {
          loadNext();
        } else {
          if (!called) {
            called = true;
            callback(spark.end());
          }
        }
      };

      //处理单片文件的上传
      function loadNext() {
        var start = currentChunk * chunkSize,
          end = start + chunkSize >= file.size ? file.size : start + chunkSize;

        fileReader.readAsBinaryString(blobSlice.call(file.raw, start, end));
      }

      loadNext();
    },
    setMD5(md5) {
      let formData = new FormData();
      // 向 formData 对象中添加文件
      // formData.append("md5", this.upload.md5);
      formData.append("file", this.file.raw);
      console.log(formData.get("file"), "formDataformData");
      let config = {
        //添加请求头
        headers: { "Content-Type": "multipart/form-data" },
        //添加上传进度监听事件
        onUploadProgress: (e) => {
          var completeProgress = (((e.loaded / e.total) * 100) | 0) + "%";
          this.progress = completeProgress;
        },
      };
      this.$http.post("/api/sku-info/importSkuInfo", formData, config).then(
        (resp) => {
          //let baseurl = this.axios.defaults.baseURL;
          this.upload = {};
          console.log(resp, '返回结果')
          if (resp.data.code == 200) {
            // 导入正确
            let path = resp.data.data.failFilePath;
            // failFilePath有的话是导入条目失败了 有失败原因
            if (path) {
              path = "/api/sku-info/templateDownload?path=" + path;
              this.axios({
                url: path,
                method: 'get',
                responseType: 'blob',
              }).then(res => {
                  console.log('res', res);
                  this.downloadCallback(res, this.getFileName(res));
                }
              ).catch(err => {
                console.log(err.message);
              });
              //window.open(`${baseurl}/api/sku-info/templateDownload?path=` + path, "_blank");
            } else {
              this.importSkuInfoShow = false;
              this.fileList = [];
              this.query();
            }
            // 提示导入信息
            setTimeout(() => {
              this.$message(resp.data.data.result);
            }, 3000);
          } else {
            let path = resp.data.failFilePath;
            if (path) {
              path = "/order/template/SKU信息维护.xlsx";
            }
            let pathT="/api/sku-info/templateDownload?path=" + path;
            this.axios({
              url: pathT,
              method: 'get',
              responseType: 'blob',
            }).then(res => {
                console.log('res', res);
                this.downloadCallback(res, this.getFileName(res));
              }
            ).catch(err => {
              console.log(err.message);
            });
            // window.open(`${baseurl}/api/sku-info/templateDownload?path=` + path, "_blank");
          }
        },
        (err) => {
          console.log("err", err);
        }
      );
    },

    uploadOrderfile(row) {
      console.log(row, "row");
      this.dialogVisible = true;
      this.Fnupload.id = row.id;
    },
    uploadBtnChange(type) {
      this.Fnupload.businessType = type;
      console.log(this.Fnupload.businessType, "this.businessType");
      if (this.Fnupload.businessType == 0) {
        this.formFilename = "PDF文件：";
      } else if (this.Fnupload.businessType == 1) {
        this.formFilename = "相关文件：";
      }

      this.fileFnList = [];
      this.uploadDialog = true;
    },
    submitFnUpload(file, fileFnList) {
      let s = file.name;
      this.fileFnList = fileFnList.slice(-1);
      this.Fnupload.file = file;
      this.generatorFileMd5(file, this.setFnMD5);
    },
    setFnMD5(md5) {
      const index = this.Fnupload.file.name.lastIndexOf(".");
      var flieArr = this.Fnupload.file.name.substring(index, this.Fnupload.file.name.length);
      // alert(flieArr)
      if (this.Fnupload.businessType == 0) {
        if (flieArr != ".pdf") {
          this.$message.error("请选择PDF文件！");
          this.fileFnList = [];
          return;
        }
      }
      let formData = new FormData();
      // 向 formData 对象中添加文件
      formData.append("file", this.Fnupload.file.raw);
      console.log(this.Fnupload.file, "formDatassssss");
      console.log(formData.get("file"), "formDataformData");
      let config = {
        //添加请求头
        headers: { "Content-Type": "multipart/form-data" },
        //添加上传进度监听事件
        onUploadProgress: (e) => {
          var completeProgress = (((e.loaded / e.total) * 100) | 0) + "%";
          this.progress = completeProgress;
        },
      };

      this.$http.post("/api/sku-info/file-upload?id=" + this.Fnupload.id + "&businessType=" + this.Fnupload.businessType, formData, config).then(
        (resp) => {
          this.Fnupload = {};
          if (resp.data.code == 200) {
            this.$message("上传成功");
            setTimeout(() => {
              this.uploadDialog = false;
              this.dialogVisible = false;
            }, 500);

            this.query();
          } else {
            this.$message("上传失败：" + resp.data.msg);
          }
        },
        (err) => {
          console.log("err", err);
        }
      );
    },
    clickFnskuDown(row) {
      this.downDialog = true;
      this.skuId = row.id;
      this.downDetailfnskuPdfPath = row.fnskuPdfPath;
    },
    downFileFnsku(businessType) {
      this.axios.get("/api/sku-info/validSkuIsDownload?id=" + this.skuId + "&businessType=" + businessType).then(
        (resp) => {
          if (resp.data.code == 200) {
            // let baseurl = this.axios.defaults.baseURL;
            // window.open(`${baseurl}/api/sku-info/fnsku-download?id=` + this.skuId + `&businessType=` + businessType, "_blank");
            let path = "/api/sku-info/fnsku-download?id=" + this.skuId + "&businessType=" + businessType;
            this.axios({
              url: path,
              method: 'get',
              responseType: 'blob',
            }).then(res => {
                console.log('res', res);
                let fileName=decodeURI((res.headers['content-disposition'].split('='))[1]);
                console.log('文件名', fileName);
                this.downloadCallback(res, fileName);
              }
            ).catch(err => {
              console.log(err.message);
            });

            setTimeout(() => {
              this.downDialog = false;
              this.$message({
                message: "下载成功",
                type: "success",
                center: true,
              });
            }, 1000);
          } else {
            this.$message.info("暂未上传文件");
          }
        },
        (err) => {
          console.log("err", err);
        }
      );
    },
  },
  mounted: function() {
    this.active = this.$route.name;
    this.query();
  },
};
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  height: calc(100vh - 70px);

  .title {
    height: 50px !important;
    color: white;
    font-size: 16px;
    background: #4c74e0;
    line-height: 50px;
    font-family: Source Han Sans CN;
    font-weight: 400;
  }
  &-content {
    background-color: white;
    height: calc(100vh - 100px);
    overflow: hidden;
  }
  /*分页插件*/
  .el-pagination {
    background-color: #fff;
    padding: 15px;
    text-align: center;
    z-index: 55555;
  }
}
.center-dialog {
  top: 20%;
}
.fs-icon{
  font-size: 24px;
  margin-right: 5px;
}
.el-pagination.is-background /deep/ .el-pager li:not(.disabled).active {
  background-color: #7698fc;
}

/*滚动条样式*/
/deep/ .scrollbar {
  white-space: nowrap;
  .el-scrollbar {
    display: flex;
    justify-content: space-around;
    padding: 0 10px;
  }
  /deep/ .el-scrollbar__wrap {
    overflow: scroll;
    width: 110%;
    height: 100%;
  }
}

.ant-card {
  width: 1230px;
  height: 600px;
  background: #ffffff;
  border-radius: 6px;

  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  transition: all 0.3s;
}
.showAll_dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  ::v-deep .el-dialog {
    margin: 0 auto !important;
    height: 80%;
    overflow: hidden;
    .el-dialog__body {
      position: absolute;
      left: 0;
      top: 54px;
      bottom: 0;
      right: 0;
      padding: 0;
      z-index: 1;
      overflow: hidden;
      overflow-y: auto;
      // 下边设置字体，我的需求是黑底白字
      color: #ffffff;
      line-height: 30px;
      padding: 0 15px;
    }
  }
}
</style>
